import { Component, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { CreateFormFrequencyStore } from './create-form-frequency.store';
import { FrequenciesMockStore } from 'src/app/shared/store-mocks/frequencies.store';

@Component({
  selector: 'app-create-form-frequency',
  templateUrl: './create-form-frequency.component.html',
  styleUrls: ['./create-form-frequency.component.scss'],
  providers: [CreateFormFrequencyStore, FrequenciesMockStore]
})
export class CreateFormFrequencyComponent implements OnInit, ControlValueAccessor {


  constructor(
    public ngControl: NgControl,
    private store: CreateFormFrequencyStore
  ) { 
    ngControl.valueAccessor = this;
  }

  vm$ = this.store.vm$
  value: any = ''

  onChange: any = () => {}
  onTouch: any = () => {}



  ngOnInit(): void {


  }

  writeValue(value: string | undefined){
    if(value){
      this.value = value
    }
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }


  frequencyChange(value: any){
    this.modelChange(value)
  }


  modelChange(value: string){
    if(!this.ngControl.touched){
      this.onTouch()
    }

    this.onChange(value)
  }

}
